export const SIGNATURE_ROLES = {
    SALES_REPRESENTATIVE: 'SR',
    SALES_REPRESENTATIVE_PROTOCOL: 'SR_PROTOCOL',
    POC: 'POC',
    POC_PROTOCOL: 'POC_PROTOCOL'
};
